import React, { useMemo } from 'react';
import {
    useProperty,
    usePropertyComplementaryData,
    usePropertyFetching,
} from '../../../contextsProperty/ContextProperties';
import Card from '../../../../muiComponents/Card';
import Tag from '../../../../muiComponents/Tag';
import LoadingTab from '../LoadingTab';
import Title from '../Title';

const Segments = () => {
    const { hostSegments, toggleItemInCollection } = useProperty();
    const { hostSegmentsList } = usePropertyComplementaryData();
    const { isFetching } = usePropertyFetching();

    const visibleSegments = useMemo(() => {
        return hostSegments.filter(segment => !segment.Deleted);
    }, [hostSegments]);

    if (isFetching) {
        return <LoadingTab />;
    }

    return (
        <div className='your-property__container'>
            <Title
                as='h1'
                text={'host_segments_title'}
                className='text-align-center'
            />
            <Card className='your-properties__form'>
                <div className='flex flex-center flex-wrap gap-20'>
                    {hostSegmentsList.map(option => {
                        const isChecked = visibleSegments.some(
                            segment =>
                                parseInt(segment.id) === parseInt(option.id)
                        );
                        return (
                            <Tag
                                key={option.id}
                                button
                                onClick={() =>
                                    toggleItemInCollection('hostSegments', {
                                        id: option.id,
                                        name: option.name,
                                    })
                                }
                                size='large'
                                color='cyan'
                                variant={isChecked ? 'contrast' : 'surface'}
                                text={option.name}
                            />
                        );
                    })}
                </div>
            </Card>
        </div>
    );
};

export default Segments;
